import http from "./http";

var baseUrl = "/appuser-web/dept";

/* 部门管理相关，写成一个组件*/

/* 查询有效子部门列表 */
const getSubService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/sub/list", reqParam, true)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/**查询部门下的子部门和人员 */

const getSubUserService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/sub/user/list", reqParam, true)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// 获取部门的负责人
const getDeptCheck = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/response/check", reqParam, true)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export { getSubService, getSubUserService, getDeptCheck };
